// @flow
import React from "react";

import ProductTitle from "../../components/ProductTitle";
import ProductPrice from "../../components/ProductPrice";
import ProductDescription from "../../components/ProductDescription";
import { connect } from "react-redux";
import { type Option } from "fp-ts/lib/Option";
import { option } from "fp-ts";
import { stockStatusSelector, priceSelector } from "../../store/modules/product";
import Badge from "../../components/Badge";
import "../../components/Badge/badge.css";
import Show from "../../functional/Show";
import Rater from "react-rater";
import "react-rater/lib/react-rater.css";

type Props = {
  productName: String,
  price: ?number,
  description: String,
  productType: "simple" | "configurable" | "giftcard",
  inStock: Option<boolean>,
  badgeTitle: String,
  ratingNumber: ?number
};

const ProductDetails = ({
  productName,
  price,
  description,
  productType,
  inStock,
  badgeTitle,
  ratingNumber
}: Props) => {
  return (
    <div className="ProductDetailsWrapper">
      <ProductTitle title={productName} h1 />
      <div className="badge-price-wrapper">
        <ProductPrice price={price} type={productType} inStock={inStock} />
        <Show when={!!badgeTitle}>
          {badgeTitle
            ? badgeTitle.split(",").map((badge, i) => <Badge key={i}>{badge}</Badge>)
            : {}}
        </Show>
      </div>
      <Show when={!!ratingNumber}>
        <div className="rating-stars-wrapper">
          <Rater total={5} rating={parseFloat(ratingNumber)} interactive={false} />
          <span className="rating-link">
            <a href="#reviews" alt="customer reviews">
              {ratingNumber} out of 5 stars
            </a>
          </span>
        </div>
      </Show>
      <ProductDescription>{description}</ProductDescription>
    </div>
  );
};

const mapStateToProps = (state: Object) => ({
  attributes: option.fromNullable(state.attributes),
  ratingNumber: state.rawProduct.customer_review_stars,
  productName: state.product.name,
  productType: state.rawProduct.type_id,
  badgeTitle: state.rawProduct.badge_list,
  description: state.product.description,
  price: priceSelector(state),
  inStock: stockStatusSelector(state)
});

export default connect(mapStateToProps)(ProductDetails);



// WEBPACK FOOTER //
// ./src/containers/ProductDetails/index.js